__turbopack_context__.v({
  "editableText": "CallTitle-module__ILOw1q__editableText",
  "icon": "CallTitle-module__ILOw1q__icon",
  "input": "CallTitle-module__ILOw1q__input",
  "large": "CallTitle-module__ILOw1q__large",
  "name": "CallTitle-module__ILOw1q__name",
  "root": "CallTitle-module__ILOw1q__root",
});
